import React, { useState } from "react";
import { ServiceProps, UserRole } from "common/";
import styles from "./styles";
import clsx from "clsx";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { tranformSchedulesForm } from "common/helpers";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Grid from "@material-ui/core/Grid";
import SubmitButton from "components/Button";
import { useTranslation } from "react-i18next";
import Checkbox from "@material-ui/core/Checkbox";
import MdCheckboxOutline from "react-ionicons/lib/MdCheckboxOutline";
import dayjs from "dayjs";

interface MSServiceProps {
  data: ServiceProps;
  openUrl: Function;
  onDelete?: Function;
  handleOpenAlert?: Function;
  approval?: boolean | false;
  handleCheck?: Function;
  fromValidateListServicesPage?: boolean | false;
  userRole: (typeof UserRole)[keyof typeof UserRole];
}

const MSService = React.memo((props: MSServiceProps) => {
  const {
    data,
    openUrl,
    handleOpenAlert,
    approval,
    fromValidateListServicesPage,
  } = props;
  const translate = useTranslation().t;
  const {
    name,
    description,
    contactEmail,
    address1,
    city,
    state,
    zip,
    phone,
    website,
    type,
    serviceSummary,
    category,
    age,
    schedules,
    isApproved,
    id,
    isContact,
    userEmail,
    lastValidatedAt,
    createdAt,
    updatedAt,
  } = data;

  const dates = [createdAt, updatedAt, lastValidatedAt].filter(Boolean);
  const latestDate =
    dates.length > 0
      ? dates.reduce((a, b) => (dayjs(a).isAfter(dayjs(b)) ? a : b))
      : null;
  const address = { address1, city, state, zip };
  const lastAddress = Object.keys(address).map((ad) => `${address[ad]}`);
  const lastSchedules = schedules && tranformSchedulesForm(schedules);
  let toLang = JSON.parse(localStorage.getItem("@shelter_language"))
    ? JSON.parse(localStorage.getItem("@shelter_language"))
    : "en";
  dayjs.locale(toLang);

  const classes = styles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<any>) => {
    setAnchorEl(event.currentTarget);
  };
  const [isCheck, setIsCheck] = useState(false);
  const handleCheck = () => {
    setIsCheck(!isCheck);
    props.handleCheck && props.handleCheck(id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    setAnchorEl(null);
    handleOpenAlert(data.id);
  };

  const handleEdit = () => {
    setAnchorEl(null);
    openUrl(`/services/${data.id}/edit`);
  };

  const renderEditButton = () => {
    return (
      <ButtonGroup fullWidth>
        <SubmitButton
          variant="contained"
          onClick={() => openUrl(`/services/${data.id}/edit`)}
        >
          {translate("EDIT_SERVICE")}
        </SubmitButton>
      </ButtonGroup>
    );
  };

  const renderDeleteButton = () => {
    return (
      <ButtonGroup fullWidth>
        <SubmitButton
          onClick={() => handleOpenAlert(data.id)}
          variant="contained"
          className={classes.bgRed}
        >
          {translate("DELETE_SERVICE")}
        </SubmitButton>
      </ButtonGroup>
    );
  };

  return (
    <>
      <div className={classes.borderItem}>
        <div className={classes.name}>
          <p className={classes.topLeft}>
            {name}
            {fromValidateListServicesPage && latestDate && (
              <span style={{ marginLeft: 8, opacity: 0.85 }}>
                ({dayjs(latestDate).format("MM/DD/YYYY")})
              </span>
            )}
          </p>
          {!fromValidateListServicesPage &&
            props.userRole !== UserRole.Volunteer && (
              <div className={classes.topRight}>
                {/* {lastValidatedAt && (
              <div className={classes.lastValidate}>
                  {translate("LAST_VALIDATED")}: {dayjs(lastValidatedAt).format("MM/DD/YYYY")}
                </div>
              )} */}
                <>
                  {approval ? (
                    <Checkbox
                      className={classes.p0}
                      checkedIcon={
                        <MdCheckboxOutline color="#6A46E5" fontSize="26px" />
                      }
                      name={""}
                      checked={isCheck}
                      onChange={(e) => {
                        if (typeof handleCheck !== "function") return null;
                        handleCheck();
                      }}
                    />
                  ) : (
                    <div onClick={handleClick}>
                      <MoreHorizIcon fontSize="small" />
                    </div>
                  )}
                </>
              </div>
            )}
          {!fromValidateListServicesPage && (
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleEdit}>
                {translate("EDIT_SERVICE")}
              </MenuItem>
              <MenuItem onClick={handleDelete}>
                {translate("DELETE_SERVICE")}
              </MenuItem>
            </Menu>
          )}
        </div>
        {!!userEmail && (
          <p>
            {translate("ADDED_BY")}: {userEmail}
          </p>
        )}
        <p>
          {translate("ADDRESS")}: {lastAddress.join(", ")}
        </p>
        <p>
          {translate("PHONE")}: {phone}
        </p>
        <p>
          {translate("EMAIL")}: {contactEmail}
        </p>
        <p>
          {translate("WEBSITE")}: {website}
        </p>
        <p>
          {translate("SERVICES")}: {type.join(", ")}
        </p>
        <p>
          {translate("SERVICE_TYPE")}: {serviceSummary}
        </p>
        <p>
          {translate("CATEGORIES")}: {category.join(", ")}
        </p>
        <p>
          {translate("AGE_GROUP")}: {age}
        </p>
        {lastSchedules.length > 0 && (
          <>
            <p>{translate("SCHEDULE")}:</p>
            {lastSchedules.map((s, idx) => (
              <p key={idx}>
                <span className={classes.w30}>{s.title}</span>
                <span className={classes.w70}>{s.date}</span>
              </p>
            ))}
          </>
        )}
        {isContact && <p>{translate("IS_SHOW_CONTACT")}</p>}
        <br />
        <p>
          {translate("COMMENT")}: {description}
        </p>
        {!approval && (
          <p
            className={clsx({
              [classes.textApproved]: isApproved,
              [classes.textNotApproved]: !isApproved,
            })}
          >
            {translate(
              isApproved
                ? "THIS_SERVICE_IS_APPROVED"
                : "THIS_SERVICE_IS_NOT_APPROVED"
            )}
          </p>
        )}

        {/* if isVolunteer, show the buttons */}
        {fromValidateListServicesPage ? (
          <ButtonGroup fullWidth>
            <SubmitButton
              variant="contained"
              onClick={() => openUrl(`/services/${data.id}/validate`)}
            >
              {translate("VALIDATE_SERVICE")}
            </SubmitButton>
          </ButtonGroup>
        ) : (
          <Grid
            style={{ paddingTop: "10px", paddingBottom: "10px" }}
            container
            spacing={1}
            direction="row"
          >
            {props.userRole === UserRole.Volunteer && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {renderEditButton()}
              </Grid>
            )}
            {props.userRole !== UserRole.Volunteer && (
              <>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  {renderEditButton()}
                </Grid>
                <Grid item xs={6} sm={6} md={6} lg={6}>
                  {renderDeleteButton()}
                </Grid>
              </>
            )}
          </Grid>
        )}
      </div>
    </>
  );
});

export default MSService;
